import React from 'react';
import Header from '../components/Header';
import SEO from '../components/SEO';

const CulturePulseProductPage = () => {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <SEO 
        title="Culture Survey Nigeria | Employee Culture Assessment Lagos"
        description="CulturePulse™ organisational culture survey for Nigerian companies. Measure workplace culture, employee engagement, and organisational health. Get actionable culture insights for your Nigerian organisation."
        keywords="culture survey Nigeria, employee survey Lagos, organisational culture assessment Nigeria, workplace culture survey Africa, culture audit Nigeria"
        canonical="https://impactasportal.com/product/culture-pulse"
      />
      <Header />
      
      {/* Main Content - Iframe Container */}
      <main className="flex-1 pt-20">
        <div className="w-full h-[calc(100vh-80px)]">
          <iframe
            src="https://impactasportal.com/product/culture-pulse?embed=true"
            title="CulturePulse™ - Impact AS Plus"
            className="w-full h-full border-0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
            allowFullScreen
            sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-downloads allow-modals allow-popups-to-escape-sandbox"
          />
        </div>
      </main>
    </div>
  );
};

export default CulturePulseProductPage;
